import { buildFaqPageJsonLd } from '@/lib/seo';
import { JsonLdScript } from '@/components/lib/JsonLdScript';
import { FaqSection } from './FaqSection';

interface FaqBlockProps {
  faqs: Array<{ question: string; answer: string }>;
  heading?: string;
  headingLevel?: 'h2' | 'h3';
  className?: string;
}

export function FaqBlock({ faqs, heading, headingLevel = 'h2', className }: FaqBlockProps) {
  if (faqs.length === 0) return null;
  const faqJsonLd = buildFaqPageJsonLd(faqs);
  return (
    <>
      <JsonLdScript data={faqJsonLd} />
      <div className={className ?? 'mt-10 border-t border-border-subtle pt-8'}>
        <FaqSection faqs={faqs} heading={heading} headingLevel={headingLevel} />
      </div>
    </>
  );
}
